export default __webpack_public_path__ + "static/media/car.7664f096.svg";